import { alpha } from "@mui/system";

import { fonts, radius } from "../shared/ticketLayout";

const styles = (theme) => ({
  container: {
    height: "85%",
    overflowY: "auto",
    pb: 2,
  },
  iconSecao: {
    fontSize: "19px",
    color: theme.palette.primary.main,
  },
  boxBody: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: 2.5,
  },

  // --- Modo de leitura ---
  blocoLeitura: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  blocoLeituraHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
  },
  blocoLeituraTitulo: {
    fontSize: fonts.chip,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  blocoLeituraTexto: {
    fontSize: fonts.reading,
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    p: 1.5,
    borderRadius: radius.card,
    backgroundColor: theme.palette.background.wallpaper,
  },
  textoVazio: {
    fontSize: fonts.body,
    fontStyle: "italic",
    color: theme.palette.text.disabled,
    p: 1.5,
  },

  // --- Modo de edição ---
  containerTextfield: {
    width: "100%",
    gap: 0.75,
    display: "flex",
    flexDirection: "column",
  },
  rotuloCampo: {
    fontSize: fonts.chip,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  campoTexto: {
    width: "100%",
    "& .MuiInputBase-input": {
      fontSize: fonts.reading,
      lineHeight: 1.6,
    },
  },
  containerButtons: {
    width: "100%",
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: "flex-end",
    gap: 1.5,
  },
  botaoCancelar: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },

  // --- Estado vazio ---
  containerWarnig: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    flexDirection: "column",
    gap: 0.5,
    py: { xs: 4, sm: 6 },
  },
  iconeVazio: {
    fontSize: "44px",
    opacity: 0.35,
    mb: 1,
  },
  titleWarning: {
    // Eram 30px: desproporcional para um estado vazio, e no celular a frase
    // quebrava em três linhas.
    fontSize: { xs: "1.0625rem", sm: "1.25rem" },
    fontWeight: 600,
    opacity: 0.75,
  },
  subtituloVazio: {
    fontSize: fonts.body,
    color: theme.palette.text.secondary,
    maxWidth: "42ch",
  },

  // --- Selo de publicado ---
  chipSelect: {
    backgroundColor: alpha(theme.palette.chip.background.success, 0.95),
    border: `1px solid ${theme.palette.chip.colorText.success}`,
    color: theme.palette.chip.colorText.success,
    fontWeight: 600,
    fontSize: fonts.chip,
    height: "24px",
    borderRadius: radius.chip,
  },
  chipStatusAnexoIcon: {
    fontSize: "13px !important",
    fill: theme.palette.chip.colorText.success,
  },
});

export default styles;
